import type { HTMLContent } from '@tiptap/core'

import { isRichtextContent, isSelectContent } from '../cell.types'

/**
 * Safely gets the content from a rich-text Cell as a HTML string
 */
export function getContentForTextCell(cellContent: unknown): HTMLContent {
  return isRichtextContent(cellContent) ? cellContent.text : ''
}

/**
 * Safely gets the content from a select Cell as a string
 */
export function getContentForSelectCell(cellContent: unknown): string {
  return isSelectContent(cellContent) ? cellContent.selected : ''
}
